import type { MultiSelectOption } from "@/components/ui/MultiSelect";
import type { SolicitacaoPagamentoDto } from "@/services/solicitacaoPagamento";
import { getStageIdForItem, type ApprovalStageId } from "./stageUtils";
import { buildHistoricoFilterOptions } from "./historicoFilters";
import { currentLocalDateInput } from "@/utils/dateInput";

export interface DashboardFilterValues {
  search: string;
  dateFrom: string;
  dateTo: string;
  etapaFilter: ApprovalStageId | "";
  fornecedorFilter: string;
  sortOrder: "recent" | "oldest" | "valor_desc" | "valor_asc";
}

export const EMPTY_DASHBOARD_FILTERS: DashboardFilterValues = {
  search: "",
  dateFrom: currentLocalDateInput(),
  dateTo: currentLocalDateInput(),
  etapaFilter: "",
  fornecedorFilter: "",
  sortOrder: "recent",
};

function fornecedorKey(item: SolicitacaoPagamentoDto): string {
  return item.creditorId?.trim() || item.creditorName?.trim() || "";
}

function itemSearchText(item: SolicitacaoPagamentoDto): string {
  return [
    item.id,
    item.solicitanteName,
    item.creditorName,
    item.descricao,
    String(item.valor),
  ]
    .join(" ")
    .toLowerCase();
}

export function filterDashboardSolicitacoes(
  items: SolicitacaoPagamentoDto[],
  filters: DashboardFilterValues,
): SolicitacaoPagamentoDto[] {
  const q = filters.search.trim().toLowerCase();

  let result = items.filter((item) => {
    if (q && !itemSearchText(item).includes(q)) return false;

    const refDate = item.createdAt.slice(0, 10);
    if (filters.dateFrom && refDate < filters.dateFrom) return false;
    if (filters.dateTo && refDate > filters.dateTo) return false;

    if (filters.etapaFilter && getStageIdForItem(item) !== filters.etapaFilter) {
      return false;
    }

    if (filters.fornecedorFilter) {
      const key = fornecedorKey(item);
      if (key !== filters.fornecedorFilter) return false;
    }

    return true;
  });

  result = [...result].sort((a, b) => {
    switch (filters.sortOrder) {
      case "oldest":
        return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      case "valor_desc":
        return b.valor - a.valor;
      case "valor_asc":
        return a.valor - b.valor;
      case "recent":
      default:
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    }
  });

  return result;
}

export function buildDashboardFilterOptions(
  items: SolicitacaoPagamentoDto[],
): { fornecedorOptions: MultiSelectOption[] } {
  const { fornecedorOptions } = buildHistoricoFilterOptions(items);
  return { fornecedorOptions };
}
